module.exports = __webpack_public_path__ + "ga.4e5e8a64d445ebedd3d3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ga.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ga.svg
// module chunks = styles